import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'

@withRouter
export default class Center extends React.Component {
  
  static propTypes = {
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={styles.Center}>
        {this.props.children}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/layout/Center/index.jsx